import { render } from "./DownloadApp.vue?vue&type=template&id=53c43f6f"
import script from "./DownloadApp.vue?vue&type=script&lang=js"
export * from "./DownloadApp.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./DownloadApp.vue?vue&type=custom&index=0&blockType=styles&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__